
















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TestC extends Vue {
    @Prop({ required: true }) loading!: boolean

    chartOptions = {
        chart: {
            height: '100%',
            width: '100%',
            type: 'bar'
        },
        colors: this.$vuetify.theme.currentTheme.primary,
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
            labels: {
                style: {
                    colors: '#fff'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#fff'
                }
            }
        },
        legend: {
            labels: {
                colors: '#fff'
            }
        },
        tooltip: {
            x: {
                show: false,
                format: 'hola'
            },
            theme: 'dark'
        }
    }

    series = [{
        data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
    }]
}
